// src/components/TeamFilter.jsx
// The Team filter used on every list (3.19.4/3.19.5): shown when the picked
// client has teams (user-info clientTeams). value '' = all teams.
import { useAuth } from '../hooks/useAuth';

export function useClientTeams() {
  const { effectiveInfo } = useAuth();
  return effectiveInfo?.clientTeams || [];
}

export const teamText = r => (r.teamNames || []).join(', ');

export default function TeamFilter({ teams, value, onChange, groupStyle, labelStyle, style, byName = false }) {
  if (!teams.length) return null;
  return (
    <div style={groupStyle}>
      <label style={labelStyle}>Team</label>
      <select value={value} onChange={e => onChange(e.target.value)} style={style} aria-label="Team">
        <option value="">All teams</option>
        {teams.map(t => <option key={t.id} value={byName ? t.name : t.id}>{t.name}</option>)}
      </select>
    </div>
  );
}
